<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M18.625 10.2013C18.625 9.60633 18.5763 9.00883 18.4738 8.42383H10.1738V11.7926H14.9263C14.8282 12.3317 14.6218 12.8453 14.3195 13.3023C14.0172 13.7593 13.6253 14.1502 13.1675 14.4513V16.6388H16.0038C17.6688 15.1138 18.625 12.8638 18.625 10.2013Z" 
    fill="#4285F4" />
    <path d="M10.175 18.7502C12.5475 18.7502 14.5487 17.9752 16.0062 16.6377L13.1712 14.4515C12.3825 14.9852 11.3638 15.2877 10.1775 15.2877C7.8825 15.2877 5.93625 13.7477 5.2375 11.6777H2.3125V13.9315C3.0495 15.383 4.17448 16.6018 5.56246 17.4525C6.95044 18.3031 8.54708 18.7524 10.175 18.7502Z" 
    fill="#34A853" />
    <path d="M5.23375 11.6775C4.86514 10.5912 4.86514 9.41373 5.23375 8.32748V6.07373H2.31125C1.6958 7.29192 1.37516 8.63765 1.37516 10.0025C1.37516 11.3673 1.6958 12.713 2.31125 13.9312L5.23375 11.6775Z" 
    fill="#FBBC04" />
    <path d="M10.175 4.7124C11.4283 4.69208 12.6397 5.1632 13.55 6.0249L16.0625 3.52615C14.4657 2.03873 12.3571 1.22393 10.175 1.25115C8.54663 1.24909 6.94961 1.69875 5.56153 2.55013C4.17346 3.40151 3.04876 4.62123 2.3125 6.07365L5.2325 8.3249C5.9275 6.2524 7.8775 4.7124 10.1725 4.7124H10.175Z" 
    fill="#EA4335" />
  </svg>
</template>

<script>
export default {
  name: 'GooglePlatformIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>